module.exports = __webpack_public_path__ + "static/media/cash-boxes.7ad8106f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/hero/cash-boxes.jpg
// module id = 1238
// module chunks = 0